import { TLoginResponseData } from "../types/loginTypes";
import { ShipInfo } from "../types/visitTypes";
import DevConsole from "./devConsole";

const STORAGE_SESSION = "SessionInfo";
const STORAGE_SHIP = "ShipInfo";

const RescoStorage = {
  getSession: (): null | TLoginResponseData => {
    const sessionJSON = localStorage.getItem(STORAGE_SESSION);
    if (
      sessionJSON &&
      (JSON.parse(sessionJSON) as TLoginResponseData)?.access_token
    ) {
      const session: TLoginResponseData = JSON.parse(
        sessionJSON
      ) as TLoginResponseData;
      DevConsole.log("Storage. Session found.", session);
      return session;
    } else {
      DevConsole.log("Storage. Session not found");
      return null;
    }
  },
  setSession: (session: TLoginResponseData) => {
    localStorage.setItem(STORAGE_SESSION, JSON.stringify(session));
    DevConsole.log("Storage. Session received.", session);
  },
  removeSession: () => {
    localStorage.removeItem(STORAGE_SESSION);
    DevConsole.log("Storage. Session removed.");
  },
  getToken: function (): string | null {
    const data = this?.getSession();
    return data ? data.access_token : null;
  },
  getShip: (): null | ShipInfo[] => {
    const shipJSON = localStorage.getItem(STORAGE_SHIP);
    if (
      shipJSON &&
      (JSON.parse(shipJSON) as ShipInfo[])
    ) {
      const ship: ShipInfo[] = JSON.parse(
        shipJSON
      ) as ShipInfo[];
      DevConsole.log("Storage. Ship info found.", ship);
      return ship;
    } else {
      DevConsole.log("Storage. Ship info not found.");
      return null;
    }
  },
  setShip: (ship: ShipInfo[]|null) => {
    localStorage.setItem(STORAGE_SHIP, JSON.stringify(ship));
    DevConsole.log("Storage. Ship info received.", ship);
  },
  removeShip: () => {
    localStorage.removeItem(STORAGE_SHIP);
    DevConsole.log("Storage. Ship info removed.");
  },
};

//Responsibility: type checking for localStorage data serialization. In other words, a typed facade for localStorage.
export default RescoStorage;
